<zxing-scanner
	#scanner
	[autofocusEnabled]="true"
	previewFitMode="fill"
	(scanComplete)="onScanEvent(scanner, $event)"
/>
